"use strict";

exports.__esModule = true;
exports.getFilteredPlanData = exports.getBackgroundColor = void 0;
var getBackgroundColor = exports.getBackgroundColor = function getBackgroundColor(remainingLife) {
  if (remainingLife < 10) {
    return "UnplannedDowntimeStateColor";
  } else if (remainingLife >= 10 && remainingLife < 20) {
    return "PlannedDowntimeStateColor";
  } else {
    return "ProducingStateColor";
  }
};
var getFilteredPlanData = exports.getFilteredPlanData = function getFilteredPlanData(data) {
  var formattedData = data.map(function (planData) {
    var threshold = planData.threshold,
      currentValue = planData.currentValue;
    var remainingLife = (threshold - currentValue) / threshold * 100;
    return Object.assign({}, planData, {
      remainingLife: remainingLife
    });
  });
  var pendingFormattedData = formattedData.filter(function (planData) {
    return planData.activityState === "Pending";
  });
  if (pendingFormattedData.length !== 0) {
    var pendingSortedData = pendingFormattedData.sort(function (a, b) {
      if (a.remainingLife !== b.remainingLife) {
        return a.remainingLife - b.remainingLife;
      }
      return new Date(a.pendingAt) - new Date(b.pendingAt);
    });
    return pendingSortedData[0];
  }
  var predictedSortedData = formattedData.sort(function (a, b) {
    if (a.remainingLife !== b.remainingLife) {
      return a.remainingLife - b.remainingLife;
    }
    return new Date(a.expectedAt) - new Date(b.expectedAt);
  });
  return predictedSortedData[0];
};